/** 来源：crm/foodbuy/market Badge；采用可透传 span 属性的公共签名与五种语义 tone。 */
import type { HTMLAttributes, ReactNode } from 'react'
import { badgeToneClasses, type Tone } from './tones'

export type BadgeTone = Tone

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & { tone?: Tone; dot?: boolean; children: ReactNode }

export function Badge({ tone = 'neutral', dot = false, className = '', children, ...props }: BadgeProps) {
  // 已知取舍：truncate 挂在 inline-flex 根上，对匿名 flex 子项（纯文本）出不了省略号——
  // 但文本节点必须直挂根上（score 等消费方按 getByText(...).className 断言 tone 类），
  // 包一层截断 span 会破坏这个 DOM 契约；需要截断长徽标的场景由调用方在 children 内自理。
  return (
    <span
      className={`inline-flex max-w-full items-center gap-1.5 self-start truncate rounded-[var(--radius-badge)] py-0.5 text-[length:var(--text-caption)] font-medium leading-5 ${badgeToneClasses[tone]} ${dot ? 'bg-transparent! px-0' : 'px-2'} ${className}`.trim()}
      {...props}
    >
      {dot ? <span className="size-[7px] shrink-0 rounded-[var(--radius-pill)] bg-current" aria-hidden="true" /> : null}
      {children}
    </span>
  )
}
